class PdpConnectedColors extends HTMLElement {
  #label = null;
  #defaultName = '';
  #list = null;
  #swatchHandlers = [];
  #onListPointerLeave = null;
  #onListFocusOut = null;

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.#label = this.querySelector('[data-ref="color-label"]');
    this.#defaultName = this.dataset.defaultColorName || this.#label?.textContent?.trim() || '';
    this.#list = this.querySelector('[data-ref="connected-colors"]');

    this.querySelectorAll('.pdp-connected-colors__swatch').forEach((swatch) => {
      const onActivate = () => {
        const name = swatch.dataset.colorName;
        if (name) this.#setLabel(name);
      };

      swatch.addEventListener('pointerenter', onActivate);
      swatch.addEventListener('focus', onActivate);
      this.#swatchHandlers.push({ swatch, onActivate });
    });

    this.#onListPointerLeave = () => this.#setLabel(this.#defaultName);
    this.#onListFocusOut = (event) => {
      if (!this.#list?.contains(event.relatedTarget)) {
        this.#setLabel(this.#defaultName);
      }
    };

    this.#list?.addEventListener('pointerleave', this.#onListPointerLeave);
    this.#list?.addEventListener('focusout', this.#onListFocusOut);
  }

  disconnectedCallback() {
    this.#swatchHandlers.forEach(({ swatch, onActivate }) => {
      swatch.removeEventListener('pointerenter', onActivate);
      swatch.removeEventListener('focus', onActivate);
    });
    this.#swatchHandlers = [];

    this.#list?.removeEventListener('pointerleave', this.#onListPointerLeave);
    this.#list?.removeEventListener('focusout', this.#onListFocusOut);
    this.#list = null;
    this.#label = null;
  }

  #setLabel(text) {
    if (this.#label && text) {
      this.#label.textContent = text;
    }
  }
}

if (!customElements.get('pdp-connected-colors')) {
  customElements.define('pdp-connected-colors', PdpConnectedColors);
}
